module.exports = __webpack_public_path__ + "static/media/121.23e7b4ea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/res/thumbnails/121.jpg
// module id = 931
// module chunks = 0